import React from 'react'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import { CARD_PROPORTION } from './constants'

const CustomDesignCropper: React.FC<{
    imageFile: string
    setCropper: Function
    isCard?: boolean
    maxHeight?: number
}> = ({ imageFile, setCropper, isCard = true, maxHeight = 400 }) => {
    return (
        <Cropper
            src={imageFile}
            style={{ maxHeight: maxHeight, width: '100%', margin: 'auto' }}
            aspectRatio={isCard ? CARD_PROPORTION : 0}
            autoCropArea={1}
            autoCrop={true}
            viewMode={1}
            guides={true}
            background={false}
            responsive={true}
            rotatable={true}
            checkOrientation={true}
            dragMode={'move'}
            onInitialized={(instance) => {
                setCropper(instance)
            }}
        />
    )
}

export default CustomDesignCropper
